import React from 'react';

import './index.scss';
import mapModifiers from 'common/utils/functions';

interface CustomLegendProps {
  labels: string[];
  colors: string[];
  onClick?: (index: number) => void; // optional, to toggle dataset
  style?: React.CSSProperties;
  hiddens?: boolean[]; // list of hidden legends
}

const KioskChartLegends: React.FC<CustomLegendProps> = ({
  labels, colors, style, hiddens = [], onClick
}) => (
  <div className="t-kioskChartLegends" style={style}>
    {labels.map((label, i) => (
      <div
        key={label}
        onClick={() => onClick?.(i)}
        className={mapModifiers('t-kioskChartLegends_item', hiddens[i] && 'hidden')}
      >
        <span
          className="t-kioskChartLegends_dot"
          style={{ backgroundColor: colors[i] }}
        />
        <span className="t-kioskChartLegends_label">{label}</span>
      </div>
    ))}
  </div>
);

export default KioskChartLegends;
